import { IReferralOrganisation, ISaveReferralOrganisation, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class ReferralOrganisationClient extends NewBaseClient<ISaveReferralOrganisation, IReferralOrganisation> {
    constructor() {
        super(supportApi, '/referral-organisations');
    }
}

export const referralOrganisationClient = new ReferralOrganisationClient();
